import styled from 'styled-components';
import { Stack } from 'common/design-system/components-v2';

export const OutputTypeSelectorWrapper = styled(Stack)`
    margin-top: 10px;
`;
